var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "setPhone-dialog-style",
      attrs: {
        width: "500px",
        title: "设置联系电话",
        visible: _vm.innerVisible,
        "append-to-body": "",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.setPhoneLoading,
              expression: "setPhoneLoading",
            },
          ],
          ref: "phoneForm",
          attrs: { model: _vm.phoneForm, "label-width": "100px" },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "phoneForm-style",
              attrs: {
                label: "联系电话",
                prop: "phone",
                rules: _vm.phoneRules,
              },
            },
            [
              _c("el-input", {
                attrs: { autocomplete: "off" },
                model: {
                  value: _vm.phoneForm.phone,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.phoneForm,
                      "phone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "phoneForm.phone",
                },
              }),
            ],
            1
          ),
          _c("span", { staticClass: "tip-style" }, [
            _vm._v(
              "提示：客户管家App/PC发起工单、处理问题件、发起理赔将优先带入此处设置的联系电话。"
            ),
          ]),
          _c(
            "div",
            { staticClass: "btn-style" },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.resetPhoneForm("phoneForm")
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitPhoneForm("phoneForm")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }